import enUS from 'src/i18n/en-us';
import deDE from 'src/i18n/de-de';
import esEs from 'src/i18n/es-es';
import ptBR from 'src/i18n/pt-br';
import frFR from 'src/i18n/fr-fr';

export default {
    'en-us': enUS,
    'de-de': deDE,
    'es-es': esEs,
    'pt-br': ptBR,
    'fr-fr': frFR,
};
